import React, {useCallback} from 'react'
import BooleanFilterItem from '@/components/pages/NewDatasetJobPage/BooleanFilterItem'
import {CircularProgress, List} from '@mui/material'
import NewJobApiError from '@/components/pages/NewDatasetJobPage/NewJobApiError'
import {StyledCenteredDiv} from '@/components/pages/NewDatasetJobPage/StyledCenteredDiv'
import {BoolFilterOptions} from '@/components/pages/NewDatasetJobPage/types'

type NewJobBooleanFiltersProps = {
    boolFilters?: BoolFilterOptions[]
    selectedFilters: Record<string, boolean>
    onFilterSelect: (filterName: string, checked: boolean, filterVal: boolean) => void
    isLoading: boolean
    error?: boolean
}

const NewJobBooleanFilters = ({boolFilters, selectedFilters, onFilterSelect, isLoading, error}: NewJobBooleanFiltersProps) => {

    const onBoolFilterSelect = useCallback((filterName: string, checked: boolean, filterVal: boolean) => {
        onFilterSelect(filterName, checked, filterVal)
    }, [])

    if(isLoading) {
        return <StyledCenteredDiv><CircularProgress /></StyledCenteredDiv>
    }

    if(error) {
        return <NewJobApiError text="Unable to load filters"/>
    }

    if(!boolFilters) {
        return <div>Select Database to load bool filters</div>
    }

    if(boolFilters.length === 0) {
        return <div>No bool filters available</div>
    }

    return <List>
        {boolFilters?.map((boolFilter: BoolFilterOptions, idx: number) => (
            <BooleanFilterItem key={'bool-filter-' + boolFilter.name + idx}
                boolFilterOpts={boolFilter}
                checked={selectedFilters[boolFilter.name] !== undefined}
                onFilterSelect={onBoolFilterSelect}
                filterValue={selectedFilters[boolFilter.name]}/>
        ))}
    </List>
}

export default NewJobBooleanFilters